module.exports = __webpack_public_path__ + "3357d3c6ddcd81e3dbdaf57b42dbd224.pdf";